<span>
  <label *ngIf="props.altLabel" [for]="field.id">{{ props.altLabel }}</label>
  <basin-chip-selector
    [formControl]="formControl"
    [formlyAttributes]="field"
    [styleClass]="props.styleClass"
    [chipList]="props.chipList ?? []"
    [selectionMode]="props.selectionMode ?? 'single'"
  ></basin-chip-selector>
</span>
